import { Box, keyframes } from "@mui/material";
import amyBot from "assets/images/newIcons/amy-bot.png";

const avatarFloat = keyframes`
  0%, 100% { transform: translate3d(0, 0, 0); }
  50% { transform: translate3d(0, -12px, 0); }
`;

export default function AmyAvatar({ size = 44, animate = true, withBackground = true }) {
  const dimension = size + (withBackground ? 10 : 0);
  const imageSize = withBackground ? Math.round(size * 0.92) : size;
  const iconCenterOffsetX = withBackground ? Math.max(3, Math.round(size * 0.1)) : 0;

  return (
    <Box
      className="amy-avatar"
      sx={{
        position: "relative",
        width: dimension,
        height: dimension,
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: withBackground ? "50%" : 0,
        overflow: "visible",
        background: withBackground
          ? "linear-gradient(145deg, #DBEAFE 0%, #93C5FD 55%, #60A5FA 100%)"
          : "transparent",
        boxShadow: withBackground
          ? "inset 0 1px 0 rgba(255,255,255,0.45), 0 2px 8px rgba(37, 99, 235, 0.2)"
          : "none",
        backgroundColor: "transparent",
      }}
    >
      <Box
        className="amy-avatar-float"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: imageSize,
          height: imageSize,
          flexShrink: 0,
          ...(animate && {
            animation: `${avatarFloat} 2.8s ease-in-out infinite`,
            willChange: "transform",
          }),
        }}
      >
        <Box
          component="img"
          src={amyBot}
          alt="Amy assistant"
          className="amy-avatar-icon"
          draggable={false}
          sx={{
            width: imageSize,
            height: imageSize,
            maxWidth: imageSize,
            maxHeight: imageSize,
            display: "block",
            objectFit: "contain",
            objectPosition: "center",
            ...(iconCenterOffsetX > 0 && {
              transform: `translateX(${iconCenterOffsetX}px)`,
            }),
            pointerEvents: "none",
            userSelect: "none",
            backgroundColor: "transparent",
            imageRendering: "-webkit-optimize-contrast",
          }}
        />
      </Box>
    </Box>
  );
}
